import { getRequest, postRequest, putRequest } from 'src/lib/core/api-client'
import { apiURI } from 'src/lib/utils/constants'
import type { PixelConfigPayload, MapEventsPayload } from 'src/lib/types/ads-iq'

const BASE = apiURI.CHECKOUT_NODE

export const getMetaOAuthUrl = () => {
  return getRequest('/dashboard/meta/authorize', BASE)
}

export const getMetaConnectionStatus = (refresh = false) => {
  return getRequest(`/dashboard/meta/status${refresh ? '?refresh=true' : ''}`, BASE)
}

export const savePixelConfig = (payload: PixelConfigPayload) =>
  postRequest('/dashboard/meta/configure', BASE, payload)

export const verifyPixel = (pixelId: string) =>
  postRequest(`/dashboard/meta/pixels/${pixelId}/verify`, BASE, {})

export const disconnectMeta = (metaUserId: string) =>
  postRequest('/dashboard/meta/disconnect', BASE, { meta_user_id: metaUserId })

export const mapEventsToPixel = (payload: MapEventsPayload) =>
  putRequest('/dashboard/meta/map-events', BASE, payload)

const toUTCTimestamp = (dateStr: string) => {
  const d = new Date(dateStr + 'T00:00:00')
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(
    d.getUTCMinutes()
  )}:${pad(d.getUTCSeconds())}`
}

export const getAdsFunnel = (params: {
  startDate: string
  endDate: string
  timeScale?: 'daily' | 'hourly'
}) => {
  return postRequest('/dashboard/meta/analytics', BASE, {
    widgetId: 'meta_utm_campaign_funnel',
    timeRange: {
      start: toUTCTimestamp(params.startDate),
      end: toUTCTimestamp(params.endDate)
    },
    timeScale: params.timeScale ?? 'daily'
  })
}

export const getEventsHealth = (params: {
  pixelIds?: string[]
  startDate: string
  endDate: string
  timeScale?: 'daily' | 'hourly'
}) => {
  return postRequest('/dashboard/meta/analytics', BASE, {
    widgetId: 'meta_event_health',
    timeRange: {
      start: toUTCTimestamp(params.startDate),
      end: toUTCTimestamp(params.endDate)
    },
    timeScale: params.timeScale ?? 'daily',
    pixelIds: params.pixelIds ?? []
  })
}

export const getEventCount = (params: {
  event_name: string
  pixel_id?: string
  start_date: string
  end_date: string
  time_scale?: string
}) => {
  const searchParams = new URLSearchParams()
  searchParams.set('event_name', params.event_name)
  if (params.pixel_id) searchParams.set('pixel_id', params.pixel_id)
  searchParams.set('start_date', params.start_date)
  searchParams.set('end_date', params.end_date)
  if (params.time_scale) searchParams.set('time_scale', params.time_scale)
  return getRequest(`/dashboard/ads/event-count?${searchParams.toString()}`, BASE)
}

export const syncFromMeta = () => postRequest('/dashboard/ads/sync', BASE, {})

export const setMetaMarketingEnabled = (enabled: boolean) =>
  putRequest('/dashboard/analytics/meta_marketing/config', BASE, { enabled })
